
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import Container from '@/components/form/container/Container.vue'
import IndustrialBankTab from '@/views/acceptance/acceptance-receipt/tabs/IndustrialBankTab.vue'
import BankOfChinaTab from '@/views/acceptance/acceptance-receipt/tabs/BankOfChinaTab.vue'
import { getBankInfoList, getCompanyAllList } from '@/apis/main-data/company'
import { CompanyListParamModel } from '@/model/master-data/companyModel'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'AcceptanceReceiptPageList',
  components: {
    BankOfChinaTab,
    IndustrialBankTab,
    Container
  },
  setup() {
    const { t } = useI18n()
    const dataMap = reactive({
      activeCode: '',
      bankList: Array<any>(),
      companys: Array<any>(),
      listLoading: true
    })
    const getBankList = async() => {
      dataMap.listLoading = true
      const params: CompanyListParamModel = {
        companyCode: null,
        name: null
      }
      const companyData = await getCompanyAllList(params)
      if (companyData?.data && companyData.data.length > 0) {
        dataMap.companys = companyData.data
      }
      const data = await getBankInfoList()
      if (data && data.data && data.data.length > 0) {
        data.data.forEach(item => {
          if (item.name.includes('中国银行') || item.name.includes('兴业银行')) {
            dataMap.bankList.push({
              name: item.name,
              companyCode: dataMap.companys.find(c => c.id === item.companyId)?.companyCode || '',
              code: item.code
            })
          }
        })
        dataMap.activeCode = dataMap.bankList[0].code
      } else {
        dataMap.bankList = []
        ElMessage({
          message: data?.msg,
          type: 'error',
          duration: 2000
        })
      }
      setTimeout(() => {
        dataMap.listLoading = false
      }, 0.5 * 1000)
    }
    onMounted(() => {
      getBankList()
    })
    return {
      t,
      ...toRefs(dataMap)
    }
  }
})
